import { useState, useEffect } from "react";

import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/gymPlaceholder.svg";
import { get, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate, useLocation } from "react-router-dom";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const GymsListing = () => {
  document.title = "Gyms Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({
    dateRange: false,
    byLocation: false,
    mostLoved: false,
  });
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);
  const [gymsData, setGymsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalId, setModalId] = useState("");
  const itemsPerPage = 6;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startSearchDate, setStartSearchDate] = useState("");
  const [endSearchDate, setEndSearchDate] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [selectedTags, setSelectedTags] = useState(
    type != null || type != undefined ? type : "By Tags"
  );

  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );
  const toggleDropdown = (gymId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [gymId]: !prevState[gymId],
    }));
  };

  const fetchGyms = async (page, searchQuery) => {
    setLoading(true);
    try {
      const response = await get(
        `${
          endpoints.gym
        }/admin?page=${page}&limit=${itemsPerPage}&search=${searchQuery}&startDate=${startSearchDate}&endDate=${endSearchDate}&filter=${
          selectedTags == "By Tags" ? "" : selectedTags
        }${
          appRole == "gymOwner" || appRole == "gymStaff" ? `&userId=${id}` : ""
        }`
      );
      setGymsData(Array.isArray(response.data?.data) ? response.data.data : []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching gyms data:", error);
      setGymsData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchGyms(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm, selectedTags]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const navigate = useNavigate();
  const handleSelectChange = async (action, gymId) => {
    if (action === "add") {
      navigate(`/add-passes?gymId=${gymId}`);
    } else if (action === "passList") {
      navigate(`/list-passes?gymId=${gymId}`);
    } else if (action === "addEquip") {
      navigate(`/add-equip?gymId=${gymId}`);
    } else if (action === "equipList") {
      navigate(`/equip-listing?gymId=${gymId}`);
    } else if (action === "modify") {
      navigate(`/edit-gyms/${gymId}`, { state: { gymId: gymId } });
    } else if (action === "gymDetails") {
      navigate(`/gym-details/:id`, { state: { gymId: gymId } });
    } else if (action === "business") {
      navigate(`/add-businessverification/:id`, { state: { gymId: gymId } });
    } else if (action === "listBank") {
      navigate(`/list-bank?gymId=${gymId}`);
    } else if (action === "addBank") {
      navigate(`/add-bank?gymId=${gymId}`);
    } else if (action === "delete") {
      console.log("Deleting gym with ID:", gymId);

      try {
        await del(`${endpoints.gym}/${gymId}`);
        setGymsData((prevData) => prevData.filter((gym) => gym._id !== gymId));
        fetchGyms(currentPage, "");
        toast.success(`Gym Deleted Successfully`, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } catch (error) {
        console.error("Error deleting gym:", error);
        alert("Failed to delete the gym.");
      }
    }
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    fetchGyms(currentPage, debouncedSearchTerm);
    setEndSearchDate("");
    setStartSearchDate("");
    setSelectedTags("By Tags");
    setSearchTerm("");
    setCurrentPage(1);
  };
  const handleClearFilters = () => {
    setSelectedTags("By Tags");
    setSearchTerm("");
    setCurrentPage(1);
  };
  useEffect(() => {
    if (startSearchDate != "" && endSearchDate != "") {
      fetchGyms(currentPage, debouncedSearchTerm);
    } else {
      fetchGyms(currentPage, debouncedSearchTerm);
    }
  }, [startSearchDate, endSearchDate]);
  function formatDate(date) {
    try {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date)
        .toLocaleDateString("en-CA", options)
        .replace(/\//g, "-");
    } catch (err) {
      console.error("Error", err);
    }
  }
  return (
    <div>
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4 ">
              <CardBody>
                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-center mb-3">
                  {/* Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Gyms
                    </span>
                    <div
                      className="w-100 w-sm-auto mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{ borderRadius: "12px", height: "48px" }}
                    >
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Filters and Buttons Section */}
                  <div className="d-flex flex-column flex-sm-row gap-2 w-100 mt-2 mt-xl-0">
                    <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                      {/* Date Range Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.dateRange}
                        toggle={() => toggleDropdown("dateRange")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center  w-100 w-xs-auto"
                        >
                          <span className="fw-normal ff-sora secondary-black font-size-14  w-100 w-xs-auto">
                            Date Range
                          </span>
                          <img
                            src={caldropdown}
                            alt="Calendar Dropdown"
                            className="ms-2"
                          />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 2 }} className="p-3">
                          <div className="d-flex flex-column">
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              Start Date
                            </span>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => {
                                setStartDate(date);
                                let temp = formatDate(date);
                                setStartSearchDate(temp);
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
                              placeholderText="Select Start Date"
                            />
                            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                              End Date
                            </span>
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => {
                                setEndDate(date);
                                let temp = formatDate(date);
                                setEndSearchDate(temp);
                              }}
                              dateFormat="yyyy/MM/dd"
                              className="form-control fw-normal ff-sora secondary-black font-size-14"
                              placeholderText="Select End Date"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={handleClearDates}
                            className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
                          >
                            Clear
                          </button>
                        </DropdownMenu>
                      </Dropdown>

                      {/* Tags Dropdown */}
                      <Dropdown
                        isOpen={dropdownOpen.byTags}
                        toggle={() => toggleDropdown("byTags")}
                        className="w-100 w-md-auto"
                      >
                        <DropdownToggle
                          caret
                          className="filter-btn d-flex justify-content-between align-items-center  w-100 w-xs-auto"
                        >
                          <span className=" w-100 w-xs-auto">
                            {selectedTags}
                          </span>
                          <img src={check} alt="Location" className="ms-2" />
                        </DropdownToggle>
                        <DropdownMenu style={{ zIndex: 1 }}>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={handleClearFilters}
                          >
                            By Tags
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedTags("NOTEWORTHY");
                            }}
                          >
                            Noteworthy
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedTags("NEWGYM");
                            }}
                          >
                            New Gym
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedTags("MOSTLOVED");
                            }}
                          >
                            Most Loved
                          </DropdownItem>
                          <DropdownItem
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setCurrentPage(1);
                              setSelectedTags("MOSTVISITED");
                            }}
                          >
                            Most Visited
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex flex-column flex-sm-row gap-2 w-100 mt-1 mt-sm-0">
                      <Button
                        className="rounded-pill1 w-auto  w-md-50"
                        color="white"
                        onClick={handleClearDates}
                      >
                        Clear
                      </Button>
                      {(appRole == "admin" || appRole == "staff") &&
                        userPermissions?.gym?.["Create Gym"] && (
                          <Button
                            className="rounded-pill w-100 w-md-auto"
                            onClick={() => {
                              navigate(`/add-gyms`);
                            }}
                          >
                            Add New
                          </Button>
                        )}
                    </div>
                  </div>
                </div>
                <div
                  className="table-responsive hide-scrollbar"
                  style={{
                    height: gymsData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead className="fixed-row">
                      <tr
                        className="ff-sora font-size-14 fw-bold primary-black"
                        style={{
                          lineHeight: "16.8px",
                        }}
                      >
                        <th>Id</th>
                        <th>Gym/Club</th>
                        <th>Location</th>
                        <th>Gym Type</th>
                        <th>Registered On</th>
                        <th>Visited By</th>
                        <th>Loved By</th>
                        <th>Saved By</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : gymsData?.length === 0 ? (
                        <></>
                      ) : (
                        gymsData.map((gym, index) => (
                          <tr
                            key={gym._id + index}
                            className="ff-sora fw-normal font-size-14 secondary-black"
                            style={{
                              lineHeight: "16.8px",
                            }}
                          >
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    gym?.logo?.data == null
                                      ? avatar
                                      : `${process.env.REACT_APP_IMG_URL}${gym?.logo?.data}`
                                  }
                                  alt={`${gym.name} logo`}
                                  className="object-fit-contain rounded-3 me-2"
                                  width={"32px"}
                                  height={"32px"}
                                />
                                <div>
                                  <h6
                                    className="ff-sora font-size-14 secondary-black"
                                    style={{
                                      lineHeight: "16.8px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {gym.name}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td>
                              {gym.address ||
                                gym.location?.formatted_address.slice(0, 40) ||
                                "N/A"}
                            </td>
                            <td>
                              {typeof gym.gymTag == "string"
                                ? gym.gymTag
                                : gym?.gymTag
                                    ?.map(
                                      (tag) =>
                                        tag.charAt(0).toUpperCase() +
                                        tag.slice(1).toLowerCase()
                                    ) // Capitalize first letter and make rest lowercase
                                    ?.join(", ")}
                            </td>

                            <td>
                              {gym.createdAt && gym.createdAt.$date
                                ? new Date(
                                    gym.createdAt.$date
                                  ).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>{gym.visitedBy || "0"} People</td>
                            <td>{gym.lovedBy || "0"} People</td>
                            <td>{gym.savedBy || "0"} People</td>
                            <td>
                              <div key={gym._id} className="gym-item rounded-2">
                                <Dropdown
                                  isOpen={dropdownOpen[gym._id]}
                                  toggle={() => toggleDropdown(gym._id)}
                                  direction="down"
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                    }}
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    {userPermissions?.passes?.[
                                      "Create Pass"
                                    ] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange("add", gym._id)
                                        }
                                      >
                                        Add Pass
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.equipment?.[
                                      "Create Equipment"
                                    ] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange(
                                            "addEquip",
                                            gym._id
                                          )
                                        }
                                      >
                                        Add Equipment
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.equipment?.[
                                      "View Equipment"
                                    ] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange(
                                            "equipList",
                                            gym._id
                                          )
                                        }
                                      >
                                        List Equipment
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.passes?.["View Pass"] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange(
                                            "passList",
                                            gym._id
                                          )
                                        }
                                      >
                                        Pass List
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.gym?.["Update Gym"] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange("modify", gym._id)
                                        }
                                      >
                                        Edit Gym
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.gym?.["View Gym"] && (
                                      <DropdownItem
                                        onClick={() =>
                                          handleSelectChange(
                                            "gymDetails",
                                            gym._id
                                          )
                                        }
                                      >
                                        Gym Details
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.gym?.["Delete Gym"] && (
                                      <DropdownItem
                                        onClick={() => {
                                          setModalOpen(true);
                                          setModalId(gym._id);
                                        }}
                                      >
                                        Delete Gym
                                      </DropdownItem>
                                    )}
                                    <DropdownItem
                                      onClick={() =>
                                        handleSelectChange("business", gym._id)
                                      }
                                    >
                                      Business Verfication
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleSelectChange("addBank", gym._id)
                                      }
                                    >
                                      Add Bank
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        handleSelectChange("listBank", gym._id)
                                      }
                                    >
                                      Bank List
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && gymsData?.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="text-center ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page, index) => (
                    <Button
                      key={index + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded-4"
      >
        <ModalHeader
          toggle={toggleModal}
          className="font-size-16 fw-medium ff-sora"
        >
          Confirm Deletion
        </ModalHeader>
        <ModalBody className="font-size-14 fw-normal ff-sora">
          Are you sure you want to delete this gym?
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className=" rounded-pill"
            onClick={() => {
              toggleModal();
              handleSelectChange("delete", modalId);
            }}
          >
            Confirm
          </Button>
          <Button color="white" className="rounded-pill1" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default GymsListing;
